import type { Subcampaign } from 'types';

type RevokedMetrics = {
  canceled: number,
  declined: number,
  expired: number
};

export function getRevokedMetrics(subcampaigns: Array<Subcampaign>): RevokedMetrics {
  return subcampaigns.reduce(
    (result, entry) => {
      switch (entry.revokedBy) {
        case 'brand':
          return {
            ...result,
            canceled: result.canceled + 1
          };
        case 'influencer':
          return {
            ...result,
            declined: result.declined + 1
          };
        case 'system':
          return {
            ...result,
            expired: result.expired + 1
          };
        default:
          return result;
      }
    },
    {
      canceled: 0,
      declined: 0,
      expired: 0
    }
  );
}
